<!-- 申请方填写故障件发货 -->
<template>
	<div class="process-page">
		<div class="create-section">
			<h3>{{ partTitleObj[repairType] }}信息</h3>
			<!-- 动态生成的零件信息部分 -->
			<div class="flex part-info-box" v-for="(part, index) in partsDetailList" :key="index">
				<div class="flex-1">
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}名称</p>
							<p class="content">{{ part.partsName }}</p>
						</div>
						<i class="el-icon-tickets"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">{{ partTitleObj[repairType] }}编号</p>
							<p class="content">{{ part.partsNumber }}</p>
						</div>
						<i class="el-icon-tickets"></i>
					</div>
					<div class="part-info-item">
						<div class="info-box">
							<p class="title">申请数量</p>
							<p class="content">{{ part.partsAmount }}</p>
						</div>
						<i class="el-icon-tickets"></i>
					</div>
				</div>
				<div class="flex-1 part-info-box-right"></div>
			</div>
			<div class="process-item">
				<el-button type="primary" @click="handleAddressInfo()">填写寄件信息</el-button>
				<el-button type="info" @click="handleDownloadPdf()">下载报告书</el-button>
			</div>
			<div class="create-footer">
				<el-button type="primary" @click="handleSubmit()">故障件发货</el-button>
			</div>
		</div>
		<AddressInfo ref="addressInfo" @update-edit="updateEdit"></AddressInfo>
		<!-- 现场技术报告书 -->
		<appendix1 ref="appendix1" />
		<!-- 零件事故报告书 -->
		<appendix2 ref="appendix2" />
		<!-- 商品问题报告书 -->
		<appendix3 ref="appendix3" />
		<!-- 流程信息 -->
		<CommonCollapse2 v-if="repairType == 2" />
		<CommonCollapse3 v-if="repairType == 3" />
	</div>
</template>
<script>
import {
	processInfo,
	claimOrdersInfo,
	claimMaterialProcessInfo,
	claimWarrantyDeliveryFault,
	claimOrdersDeliveryFault,
	claimMaterialDeliveryFault,
} from "@/api/claim";
import AddressInfo from "../components/sendAddressInfo.vue";
import appendix1 from "@/components/PdfTemplate/AppendixReport/appendix1.vue";
import appendix2 from "@/components/PdfTemplate/AppendixReport/appendix2.vue";
import appendix3 from "@/components/PdfTemplate/AppendixReport/appendix3.vue";
import CommonCollapse2 from "../components/CommonCollapse2.vue";
import CommonCollapse3 from "../components/CommonCollapse3.vue";
import { debounce } from "@/utils/debounce";
export default {
	data() {
		return {
			relatedId: "",
			repairType: "",
			remark: "",
			partsDetailList: [],
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			innerAdvanceCode: "",
			applyAdvanceCode: "",
			edit: "0",
			form: null,
		};
	},
	components: {
		appendix1,
		appendix2,
		appendix3,
		AddressInfo,
		CommonCollapse2,
		CommonCollapse3,
	},
	mounted() {
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId");
		const repairType = sessionStorage.getItem("repairType");
		if (repairType == "1") {
			this.getClaimWarrantyInfo(claimId);
		} else if (repairType == "2") {
			this.getClaimOrdersInfo(claimId);
		} else {
			this.getClaimMaterialInfo(claimId);
		}
	},
	methods: {
		// 获取单个索赔信息
		getClaimWarrantyInfo(claimId) {
			let self = this;
			processInfo(claimId, true)
				.then((r) => {
					self.relatedId = r.data.partsClaimWarranty.id;
					self.repairType = r.data.repairType;
					self.partsDetailList = [...r.data.partsDetailList];
					self.innerAdvanceCode = r.data.partsClaimWarranty.innerAdvanceCode;
					self.applyAdvanceCode = r.data.partsClaimWarranty.applyAdvanceCode;
					self.form = r.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaimOrdersInfo(claimId) {
			let self = this;
			claimOrdersInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.relatedId = r.data.partsClaimOrders.id;
						self.repairType = r.data.repairType;
						self.partsDetailList = [...r.data.partsDetailList];
						self.innerAdvanceCode = r.data.partsClaimOrders.innerAdvanceCode;
						self.applyAdvanceCode = r.data.partsClaimOrders.applyAdvanceCode;
						self.form = r.data;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		getClaimMaterialInfo(claimId) {
			let self = this;
			claimMaterialProcessInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.relatedId = r.data.partsClaimMaterial.id;
						self.repairType = r.data.repairType;
						self.partsDetailList = [...r.data.partsDetailList];
						self.innerAdvanceCode = r.data.partsClaimMaterial.innerAdvanceCode;
						self.applyAdvanceCode = r.data.partsClaimMaterial.applyAdvanceCode;
						self.form = r.data;
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
				});
		},
		handleSubmit: debounce(function () {
			console.log(this.$refs.addressInfo.dataForm);
			if (this.edit == "0") {
				this.$message.error(`请填写寄件信息`);
				return;
			}
			const dataForm = this.$refs.addressInfo.dataForm;
			// 请确认系统打印报告书已和故障件一起打包寄出
			let self = this;
			this.$confirm("请确认系统打印报告书已和故障件一起打包寄出", "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					if (self.repairType == "1") {
						claimWarrantyDeliveryFault(dataForm, true)
							.then((r) => {
								if (r.code == "0") {
									self.$message.success("保存成功");
									self.$router.push({
										name: "claimApplicationList",
									});
								} else {
									self.$message.error(r.msg);
								}
							})
							.catch((error) => {
								console.log(error);
							});
					} else if (self.repairType == "2") {
						claimOrdersDeliveryFault(dataForm, true)
							.then((r) => {
								if (r.code == "0") {
									self.$message.success("保存成功");
									self.$router.push({
										name: "claimApplicationList",
									});
								} else {
									self.$message.error(r.msg);
								}
							})
							.catch((error) => {
								console.log(error);
							});
					} else {
						claimMaterialDeliveryFault(dataForm, true)
							.then((r) => {
								if (r.code == "0") {
									self.$message.success("保存成功");
									self.$router.push({
										name: "claimApplicationList",
									});
								} else {
									self.$message.error(r.msg);
								}
							})
							.catch((error) => {
								console.log(error);
							});
					}
				})
				.catch(() => {});
		}, 1000),
		// 寄件信息已修改
		updateEdit(newValue) {
			this.edit = newValue;
		},
		// 新增地址
		handleAddressInfo() {
			const linkTables = {
				1: "parts_claim_warranty",
				2: "parts_claim_orders",
				3: "parts_claim_material",
			};
			this.$refs.addressInfo.init({
				id: this.relatedId,
				linkTable: linkTables[this.repairType],
				expressType: "1",
				applyAdvanceCode: this.applyAdvanceCode,
				innerAdvanceCode: this.innerAdvanceCode,
				edit: this.edit,
			});
		},
		// 下载pdf
		handleDownloadPdf() {
			// 默认模板
			const newForm = {
				...this.$data,
			};
			if (!newForm) {
				console.error("默认模板 data is undefined");
				return;
			}
			if (this.repairType == "1") {
				this.$refs.appendix1.init(newForm);
			} else if (this.repairType == "2") {
				this.$refs.appendix2.init(newForm);
			} else if (this.repairType == "3") {
				this.$refs.appendix3.init(newForm);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.process-page ::v-deep .el-collapse-item__header {
	height: 60px;
	line-height: unset;
}
.title-content {
	width: 100%;
}
.title-box {
	display: flex;
	&:first-child {
		margin-bottom: 10px;
		span {
			font-size: 1rem;
			font-weight: 400;
			line-height: 1.5;
			letter-spacing: 0.00938em;
		}
	}
	span {
		flex: 1;
		&:last-child {
			text-align: right;
			margin-right: 20px;
		}
	}
}
.create-section {
	border-top: 1px solid #ddd;
	padding-top: 20px;
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
h3 {
	margin-left: 10px;
}
.part-info-box {
	margin: 10px 5px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
}
.create-footer {
	text-align: right;
	margin-top: 20px;
	padding: 20px;
	border-top: 1px solid #ddd;
}
.process-item {
	margin-top: 10px;
	p {
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.75;
		letter-spacing: 0.00938em;
		margin-bottom: 10px;
	}
}
</style>
